import { inject, Injectable } from '@angular/core';
import { Store } from '@ngxs/store';

import { StorageService } from '@pe/checkout/storage';
import { CheckoutWindow, CheckoutSettingsInterface } from '@pe/checkout/types';

import { ACCESS_TOKEN_NAME } from '../auth';

import { InitSettings } from './settings.actions';

@Injectable({
  providedIn: 'root',
})
export class SettingsActionHandler {
  private readonly storage = inject(StorageService);
  private readonly loader = (window as CheckoutWindow).pe_pageCheckoutLoader;


  constructor(
    private readonly store: Store,
  ) {
    if (this.loader?.checkoutData) {
      this.store.dispatch(new InitSettings(this.loader.checkoutData));
    } else if (this.loader) {
      this.loader.successCallback = (data: CheckoutSettingsInterface) => {
        this.store.dispatch(new InitSettings(data));
      };

      this.loader.errorCallback = () => {
        this.storage.remove(ACCESS_TOKEN_NAME);
      };
    }
  }
}
